import { BaseEntity } from 'yt-ng-framework';

export class VerskiPraznik extends BaseEntity {
    constructor(){
        super();
    }
    Naziv: string=null;
    Dan: number=null;
    Mesec: number=null;
    Godina: number=null;

    Deserialize(input: any){
        this.ID = input.ID;
        this.Naziv = input.Naziv;
        this.Dan = input.Dan;
        this.Mesec= input.Mesec;
        this.Godina=input.Godina;
        return this;
    }

    Serialize(input: VerskiPraznik){
        return input;
    }
}
